
(function () {
    XonBoard.ColorMaps = {
        render: function (selector, options) {
        }
    }
})();
